module.exports = __webpack_public_path__ + "img/submit-success.047a624ab.svg";